import { ChainId } from '../sdk/chainId'
import { Currency, Token } from '../sdk'
import { isNativeCurrency, nativeCurrencyId } from '../config/native'

export function currencyId(currency: Currency, chainId: ChainId): string {
  if (isNativeCurrency(currency, chainId)) {
    return nativeCurrencyId(chainId)
  }
  if (currency instanceof Token) {
    return currency.address
  }
  throw new Error('invalid currency')
}
